'use client'

import React, { useEffect } from 'react'
import { cn } from '~/lib/utils'

type AdBannerTypes = {
    dataAdSlot: string
    dataAdFormat: string
    dataFullWidthResponsive: boolean
    className?: string
}

const AdBanner = ({ dataAdSlot, dataAdFormat, dataFullWidthResponsive, className }: AdBannerTypes) => {
    useEffect(() => {
        try {
            ;((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({})
        } catch (error: any) {
            console.log(error.message)
        }
    }, [])

    return (
        <div className={cn(className)}>
            <ins
                className='adsbygoogle justify-center bg-primary'
                style={{ display: 'flex' }}
                data-ad-client='ca-pub-3824367528466265'
                data-ad-slot={dataAdSlot}
                data-ad-format={dataAdFormat}
                data-full-width-responsive={dataFullWidthResponsive.toString()}
            ></ins>
        </div>
    )
}

export default AdBanner
